// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-A4A","select":"styles_select__aMCZS"};